import React from "react";
import Select from "react-select";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { getStorageData } from "../../utils/Validate";

const CustomerMasterFilter = (props) => {
  const style = {
    control: (base) => ({
      ...base,
      boxShadow: "none",
      border: "1px solid #B4BABF",
      backgroundColor: "#F9FBFC",
      fontSize: "14px",
      minHeight: "35px",
      height: "35px",
      borderRadius: "6px",
      color: "#000000",
      whiteSpace: "nowrap",
    }),
  };

  const {
    distributors,
    handleFilterChange,
    setCountry,
    handleLabelFilterChange,
    setSalesEng,
    salesEngineer,
    customerStatus,
    setStatus,
    salesEng,
    customerTypeDrp,
    customerTypeName,
    handleTypeFilterChange,
    CustomerFilter,
    countrydata,
    country,
    ClearFilter,
    ApplyFilter,
    status,
    setDistributors,
    distributor,
  } = props;

  return (
    <>
      <div
        className="modal fade drawer right-align"
        id="filterRightSideModalPopup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="filterRightSideModalPopupLabel"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <i className="fas fa-filter"></i>
              <h5 className="modal-title">Filters</h5>
              <i className="fas fa-times" data-dismiss="modal"></i>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {getStorageData()?.userType!==2 && (<div className="mt-2">
                    <label>Distributor</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR}
                      pageName="customerList"
                      dpDownName="distributor"
                      stateData={distributor}
                      controlName="distributordrp"
                      handleChange={(e) => {
                        handleFilterChange(e, "distributorId");
                      }}
                      value={distributors}
                      valueId={CustomerFilter?.distributors}
                      setState={setDistributors}
                      checkLabel={true}
                      styles={style}
                    />
                  </div>)}
                  <div className="mt-2">
                    <label>Sales Engineer</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_SALES_ENGINEER}
                      pageName="customerList"
                      dpDownName="assignedTo"
                      stateData={salesEngineer}
                      controlName="salesdrp"
                      handleChange={(e) => {
                        handleFilterChange(e, "assignedEngineerId");
                      }}
                      value={salesEng}
                      valueId={CustomerFilter?.salesEng}
                      setState={setSalesEng}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Customer Type</label>
                    <Select
                      hideSelectedOptions={false}
                      name="customerTypeDrp"
                      options={customerTypeDrp}
                      className="basic-multi-select"
                      value={customerTypeName}
                      onChange={handleTypeFilterChange}
                      placeholder="All"
                      isClearable={true}
                      styles={style}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Customer Status</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_STATUS}
                      pageName="customerList"
                      dpDownName="customerStatus"
                      stateData={customerStatus}
                      controlName="statusdrp"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "status");
                      }}
                      value={status}
                      valueId={CustomerFilter?.status}
                      setState={setStatus}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Country</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_COUNTRY}
                      pageName="customerList"
                      dpDownName="country"
                      stateData={countrydata}
                      controlName="countrydrp"
                      handleChange={(e) => {
                        handleLabelFilterChange(e, "countryName");
                      }}
                      value={country}
                      valueId={CustomerFilter?.country}
                      setState={setCountry}
                      checkLabel={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-modal">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn clear-all-btn"
                      data-dismiss="modal"
                      onClick={(e) => ClearFilter()}
                    >
                      Clear all
                    </button>
                    <button
                      type="button"
                      className="btn apply-btn"
                      data-dismiss="modal"
                      onClick={(e) => ApplyFilter()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerMasterFilter;
